import { SvgIcon } from '@mui/material'

// Types
import { SvgIconProps } from '@mui/material'

const FlashIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 27 27">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={2}
				strokeMiterlimit={20}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M6.85124 14.94H10.3275V23.04C10.3275 24.93 11.3512 25.3125 12.6 23.895L21.1162 14.22C22.1625 13.0388 21.7237 12.06 20.1375 12.06H16.6612V3.96001C16.6612 2.07001 15.6375 1.68751 14.3887 3.10501L5.87249 12.78C4.83749 13.9725 5.27624 14.94 6.85124 14.94Z"
			/>
		</SvgIcon>
	)
}

export default FlashIconAtom
